import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../api";
import Layout from "../components/Layout";
import Seo from "../components/Seo";

export default function Destination() {
  const { slug } = useParams();
  const [item, setItem] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    api(`/api/destinations/${slug}`).then(setItem).catch((err) => setError(err.message));
  }, [slug]);
  if (error) return <Layout><section className="section"><p className="error">{error}</p></section></Layout>;
  if (!item) return <Layout><section className="section">Loading…</section></Layout>;
  return (
    <Layout>
      <Seo title={`${item.title}, Sri Lanka`} description={item.summary} path={`/destinations/${item.slug}`} image={item.image} />
      <header className="article-hero" style={{ backgroundImage: `linear-gradient(transparent, rgba(0,0,0,.55)), url(${item.image})` }}>
        <div className="wrap">
          <p className="eyebrow">{item.region} · {item.feeling}</p>
          <h1 className="display">{item.title}</h1>
        </div>
      </header>
      <section className="section">
        <div className="wrap prose">
          <p>{item.summary}</p>
          <p><Link className="btn" to={`/enquire?journey=${encodeURIComponent(item.title)}`}>Plan {item.title}</Link></p>
        </div>
      </section>
    </Layout>
  );
}
